/**
 * Generated by orval v8.4.1 🍺
 * Do not edit manually.
 * Supabase API (v1)
 * Supabase API generated from the OpenAPI specification.<br>Visit [https://supabase.com/docs](https://supabase.com/docs) for a complete documentation.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateOrganizationV1,
  OrganizationProjectClaimResponse,
  OrganizationResponseV1,
  V1OrganizationMemberResponse,
  V1OrganizationSlugResponse
} from './supabaseAPIV1.schemas';

import { customFetch } from '../fetcher';


/**
 * Returns a list of organizations that you currently belong to.
 * @summary List all organizations
 */
export type v1ListAllOrganizationsResponse200 = {
  data: OrganizationResponseV1[]
  status: 200
}

export type v1ListAllOrganizationsResponse500 = {
  data: void
  status: 500
}

export type v1ListAllOrganizationsResponseSuccess = (v1ListAllOrganizationsResponse200) & {
  headers: Headers;
};
export type v1ListAllOrganizationsResponseError = (v1ListAllOrganizationsResponse500) & {
  headers: Headers;
};

export type v1ListAllOrganizationsResponse = (v1ListAllOrganizationsResponseSuccess | v1ListAllOrganizationsResponseError)

export const getV1ListAllOrganizationsUrl = () => {


  

  return `/v1/organizations`
}

export const v1ListAllOrganizations = async ( options?: RequestInit): Promise<v1ListAllOrganizationsResponse> => {
  
  return customFetch<v1ListAllOrganizationsResponse>(getV1ListAllOrganizationsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Create an organization
 */
export type v1CreateAnOrganizationResponse201 = {
  data: OrganizationResponseV1
  status: 201
}

export type v1CreateAnOrganizationResponse500 = {
  data: void
  status: 500
}

export type v1CreateAnOrganizationResponseSuccess = (v1CreateAnOrganizationResponse201) & {
  headers: Headers;
};
export type v1CreateAnOrganizationResponseError = (v1CreateAnOrganizationResponse500) & {
  headers: Headers;
};

export type v1CreateAnOrganizationResponse = (v1CreateAnOrganizationResponseSuccess | v1CreateAnOrganizationResponseError)

export const getV1CreateAnOrganizationUrl = () => {


  

  return `/v1/organizations`
}

export const v1CreateAnOrganization = async (createOrganizationV1: CreateOrganizationV1, options?: RequestInit): Promise<v1CreateAnOrganizationResponse> => {
  
  return customFetch<v1CreateAnOrganizationResponse>(getV1CreateAnOrganizationUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createOrganizationV1,)
  }
);}
  

/**
 * @summary List members of an organization
 */
export type v1ListOrganizationMembersResponse200 = {
  data: V1OrganizationMemberResponse[]
  status: 200
}

export type v1ListOrganizationMembersResponseSuccess = (v1ListOrganizationMembersResponse200) & {
  headers: Headers;
};
;

export type v1ListOrganizationMembersResponse = (v1ListOrganizationMembersResponseSuccess)

export const getV1ListOrganizationMembersUrl = (slug: string,) => {


  

  return `/v1/organizations/${slug}/members`
}

export const v1ListOrganizationMembers = async (slug: string, options?: RequestInit): Promise<v1ListOrganizationMembersResponse> => {
  
  return customFetch<v1ListOrganizationMembersResponse>(getV1ListOrganizationMembersUrl(slug),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Gets information about the organization
 */
export type v1GetAnOrganizationResponse200 = {
  data: V1OrganizationSlugResponse
  status: 200
}

export type v1GetAnOrganizationResponse401 = {
  data: void
  status: 401
}

export type v1GetAnOrganizationResponse403 = {
  data: void
  status: 403
}

export type v1GetAnOrganizationResponse429 = {
  data: void
  status: 429
}

export type v1GetAnOrganizationResponseSuccess = (v1GetAnOrganizationResponse200) & {
  headers: Headers;
};
export type v1GetAnOrganizationResponseError = (v1GetAnOrganizationResponse401 | v1GetAnOrganizationResponse403 | v1GetAnOrganizationResponse429) & {
  headers: Headers;
};

export type v1GetAnOrganizationResponse = (v1GetAnOrganizationResponseSuccess | v1GetAnOrganizationResponseError)

export const getV1GetAnOrganizationUrl = (slug: string,) => {


  

  return `/v1/organizations/${slug}`
}

export const v1GetAnOrganization = async (slug: string, options?: RequestInit): Promise<v1GetAnOrganizationResponse> => {
  
  return customFetch<v1GetAnOrganizationResponse>(getV1GetAnOrganizationUrl(slug),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Gets project details for the specified organization and claim token
 */
export type v1GetOrganizationProjectClaimResponse200 = {
  data: OrganizationProjectClaimResponse
  status: 200
}

export type v1GetOrganizationProjectClaimResponse401 = {
  data: void
  status: 401
}

export type v1GetOrganizationProjectClaimResponse403 = {
  data: void
  status: 403
}

export type v1GetOrganizationProjectClaimResponse429 = {
  data: void
  status: 429
}

export type v1GetOrganizationProjectClaimResponseSuccess = (v1GetOrganizationProjectClaimResponse200) & {
  headers: Headers;
};
export type v1GetOrganizationProjectClaimResponseError = (v1GetOrganizationProjectClaimResponse401 | v1GetOrganizationProjectClaimResponse403 | v1GetOrganizationProjectClaimResponse429) & {
  headers: Headers;
};

export type v1GetOrganizationProjectClaimResponse = (v1GetOrganizationProjectClaimResponseSuccess | v1GetOrganizationProjectClaimResponseError)

export const getV1GetOrganizationProjectClaimUrl = (slug: string,
    token: string,) => {


  

  return `/v1/organizations/${slug}/project-claim/${token}`
}

export const v1GetOrganizationProjectClaim = async (slug: string,
    token: string, options?: RequestInit): Promise<v1GetOrganizationProjectClaimResponse> => {
  
  return customFetch<v1GetOrganizationProjectClaimResponse>(getV1GetOrganizationProjectClaimUrl(slug,token),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Claims project for the specified organization
 */
export type v1ClaimProjectForOrganizationResponse204 = {
  data: void
  status: 204
}

export type v1ClaimProjectForOrganizationResponse401 = {
  data: void
  status: 401
}

export type v1ClaimProjectForOrganizationResponse403 = {
  data: void
  status: 403
}

export type v1ClaimProjectForOrganizationResponse429 = {
  data: void
  status: 429
}

export type v1ClaimProjectForOrganizationResponseSuccess = (v1ClaimProjectForOrganizationResponse204) & {
  headers: Headers;
};
export type v1ClaimProjectForOrganizationResponseError = (v1ClaimProjectForOrganizationResponse401 | v1ClaimProjectForOrganizationResponse403 | v1ClaimProjectForOrganizationResponse429) & {
  headers: Headers;
};

export type v1ClaimProjectForOrganizationResponse = (v1ClaimProjectForOrganizationResponseSuccess | v1ClaimProjectForOrganizationResponseError)

export const getV1ClaimProjectForOrganizationUrl = (slug: string,
    token: string,) => {


  

  return `/v1/organizations/${slug}/project-claim/${token}`
}

export const v1ClaimProjectForOrganization = async (slug: string,
    token: string, options?: RequestInit): Promise<v1ClaimProjectForOrganizationResponse> => {
  
  return customFetch<v1ClaimProjectForOrganizationResponse>(getV1ClaimProjectForOrganizationUrl(slug,token),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

